<template>
  <section>
    <b-navbar class="bg-white">
      <b-navbar-brand v-if="!backButton">
        <LogoSvg :style="$store.getters['pageParams/secondaryColor']" />
      </b-navbar-brand>

      <b-navbar-brand v-else>
        <div class="d-flex flex-row mt-1">
          <div id="back-button" v-on:click="pushRoute()">
            <b>&#8249;</b> {{ $t("back") }}
          </div>
        </div>
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <span
          id="span-title"
          :style="$store.getters['pageParams/secondaryColor']"
          >{{ title }}</span
        >
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-button
          v-if="showClose"
          variant="white"
          id="button-close"
          @click="closeApp()"
          :style="$store.getters['pageParams/secondaryColor']"
        >
          <CloseSvg />
        </b-button>
      </b-navbar-nav>
    </b-navbar>
    <hr id="hr-header" />
  </section>
</template>

<script>
import LogoSvg from "./../../assets/images/tailie-logo-sm.svg";
import CloseSvg from "./../../assets/images/close.svg";

export default {
  name: "ui-header",
  components: {
    LogoSvg,
    CloseSvg
  },
  props: {
    showClose: {
      type: Boolean,
      default: true
    }
  },
  created() {
    console.log("created");
    if (
      this.$route.fullPath === "/" ||
      this.$route.fullPath === "/auth/login"
    ) {
      this.backButton = false;
    } else if (this.$route.fullPath.includes("/try-now")) {
      this.backButton = false;
    } else {
      this.backButton = true;
    }
  },
  watch: {
    $route(to) {
      this.backButton = !(to.fullPath === "/" || to.fullPath === "/auth/login");
    }
  },
  data() {
    return {
      backButton: false,
      title: ""
    };
  },
  methods: {
    closeApp() {
      this.$store.dispatch("application/close");
    },
    pushRoute() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
#back-button {
  line-height: 25px;
  font-size: 15px;
}

#span-title {
  color: #000000;
  font-family: Gilroy-Bold;
  font-size: 12px;
  text-transform: uppercase;
  transform: matrix(1, 0, 0, 1, 0, 2.5);
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#button-close {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-weight: 100;
  line-height: 25px;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#hr-header {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
